var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLikeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.30233 14H2.95349V5.10526H2.30233C1.95693 5.10526 1.62568 5.24944 1.38144 5.50607C1.13721 5.76269 1 6.11076 1 6.47368V12.6316C1 12.9945 1.13721 13.3426 1.38144 13.5992C1.62568 13.8558 1.95693 14 2.30233 14ZM13.6977 5.10526H9.13953L9.87014 2.80084C9.93533 2.59518 9.95309 2.37618 9.92195 2.1619C9.89082 1.94761 9.81168 1.74416 9.69105 1.5683C9.57043 1.39245 9.41177 1.24922 9.22815 1.15041C9.04452 1.05161 8.84118 1.00006 8.63488 1H8.48837L5.23256 4.72074V14H12.3953L14.9427 8.11853L15 7.84211V6.47368C15 6.11076 14.8628 5.76269 14.6186 5.50607C14.3743 5.24944 14.0431 5.10526 13.6977 5.10526Z",
    stroke: "#CED3E0",
    strokeWidth: 1.5
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeIcon);
export default __webpack_public_path__ + "static/media/like-icon.eaceeb1c.svg";
export { ForwardRef as ReactComponent };